import React from 'react';
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-5 border-y border-border-light px-4 relative overflow-hidden" data-id="element-431">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-432"></div>

      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 text-center relative z-10" data-id="element-433">
        <div className="flex flex-col items-center justify-center" data-id="element-434">
          <span className="text-2xl sm:text-3xl font-black text-primary drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]" data-id="element-435">
            +20K
          </span>
          <span className="text-text-sec text-xs sm:text-sm font-medium mt-1" data-id="element-436">
            Entrenadores en la comunidad global 🌎
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-437">
          <span className="text-2xl sm:text-3xl font-black text-primary drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]" data-id="element-438">
            1.500+
          </span>
          <span className="text-text-sec text-xs sm:text-sm font-medium mt-1" data-id="element-439">
            Clubes y academias lo utilizan
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-440">
          <span className="text-2xl sm:text-3xl font-black text-primary drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]" data-id="element-441">
            420K+
          </span>
          <span className="text-text-sec text-xs sm:text-sm font-medium mt-1" data-id="element-442">
            Drills descargados este año
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-443">
          <span className="text-2xl sm:text-3xl font-black text-primary drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]" data-id="element-444">
            96%
          </span>
          <span className="text-text-sec text-xs sm:text-sm font-medium mt-1" data-id="element-445">
            Ahorran +6 horas de "escritorio"
          </span>
        </div>
      </div>
    </section>;
}